import React from 'react';
import propTypes from 'prop-types';
import {
  Button,
  ModalCardBody,
  ModalCardHeader,
  ModalCardTitle,
  ModalCard,
  ModalBackground,
  Modal,
  CardContent,
} from 'src/ui/mui-ui-kit';
import {
  usePoseWithBulma,
  FadeInDiv,
  AnimatedCard,
  UiQuillAdapter,
} from 'src/ui';
import { Field } from 'react-final-form';
import { ACCOUNT_STATUS } from 'src/account';
import { composeValidators, required } from 'src/ui/validations';

export function RespondModal({
  action,
  isActive,
  onClickClose,
  hasValidationErrors,
}) {
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );

  return (
    <Modal isActive={isModalVisible} className="confirm-changes-modal">
      <ModalBackground
        tag={FadeInDiv}
        pose={currentPose}
        onPoseComplete={onPoseComplete}
      />
      <ModalCard tag={AnimatedCard} pose={currentPose}>
        <ModalCardHeader>
          <ModalCardTitle
            tag="h6"
            hasTextAlign="centered"
            className="has-text-weight-semibold"
          >
            {action === ACCOUNT_STATUS.ACTIVE
              ? 'Approve Merchant'
              : 'Deny Merchant'}
          </ModalCardTitle>
        </ModalCardHeader>
        <ModalCardBody>
          <CardContent className="has-text-grey-medium-dark">
            {action === ACCOUNT_STATUS.ACTIVE ? (
              <p>
                I have reviewed the onboarding package and are satisfied to
                approve this merchant for financial services.
              </p>
            ) : (
              <p>
                I have reviewed the onboarding package and need additional
                information provided to approve this merchant.
              </p>
            )}
          </CardContent>
          <Field
            component={UiQuillAdapter}
            name="explanation"
            id="explanation"
            label=""
            placeholder="Send a message to the merchant."
            required
            validate={composeValidators('Message', required)}
          />
          <div className="buttons is-centered">
            <Button
              isColor="gradient-bright"
              className="is-long"
              type="submit"
              disabled={hasValidationErrors}
            >
              Submit
            </Button>
            <Button
              isOutlined
              className="is-long"
              hasTextColor="info"
              onClick={onClickClose}
            >
              Close
            </Button>
          </div>
        </ModalCardBody>
      </ModalCard>
    </Modal>
  );
}

RespondModal.propTypes = {
  action: propTypes.oneOf(['', ACCOUNT_STATUS.ACTIVE, ACCOUNT_STATUS.SUBMITTED])
    .isRequired,
  isActive: propTypes.bool.isRequired,
  hasValidationErrors: propTypes.bool.isRequired,
  onClickClose: propTypes.func.isRequired,
};
